// extracted by mini-css-extract-plugin
export var modal = "_g6-0";